import { useState } from 'react';

import PageTitle from '../components/pagetitle/PageTitle';
import About2 from '../components/about/About2';
import Counter from '../components/counter/Counter';
import Portfolio from '../components/portfolio/Portfolio';
import Team from '../components/team/Team';
import dataTeam from '../assets/fake-data/dataTeam';
import Footer from '../components/footer/Footer';
import dataPortfolio from '../assets/fake-data/data-portfolio';

import Button from '../components/button/Button';

import img1 from '../assets/images/layouts/about-01.png'
import img2 from '../assets/images/layouts/about-02.png'
import img3 from '../assets/images/layouts/about-03.png'
import img5 from '../assets/images/layouts/about-05.png'



function About(props) {

    const [dataImg] = useState([
        { id: 1, img: img1, class: 'img1' },
        { id: 2, img: img2, class: 'img2' },
        { id: 3, img: img3, class: 'img3' },
        { id: 5, img: img5, class: 'img5' },
    ]);

    return (
        <div className='page-about wrapper'>

            <PageTitle title='About Me' />

            <About2 />

            <Counter />

            <section className="about">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-md-12">
                            <div className="about__right">
                                <div className="images">
                                    {dataImg.map(idx => (
                                        <img key={idx.id} className={idx.class} src={idx.img} alt="Jacob Rajan" />
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div className="block-text">
                                <h6 className="sub-heading"><span>Vision</span></h6>
                                <h3 className="heading wow" data-splitting>My Vision</h3>
                                <p className="mb-17">To build digital products that genuinely improve how people work — combining engineering precision with thoughtful design. I believe great software should be fast, accessible, and a pleasure to use, not just functional.</p>
                            </div>
                            <div className="block-text">
                                <h6 className="sub-heading"><span>Mission</span></h6>
                                <h3 className="heading wow" data-splitting>My Mission</h3>
                                <p>To help businesses and founders ship enterprise-grade web products with confidence — from architecture to deployment. I take ownership of every layer of the stack, bringing clarity, speed, and long-term maintainability to every project I take on.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Portfolio data={dataPortfolio} />

            <Team data={dataTeam} />

            <section className="create">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="create__main">
                                <div className="content">
                                    <h4 className="heading">Let's Build Something Great</h4>
                                    <p>Looking for a Senior Full-Stack Engineer? Let's connect.</p>
                                    <Button title='Hire Me' link='/contact' />
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            
        </div>
    );
}

export default About;